import * as types from "./types";

export const initialFetchReport = (payload) => ({
  type: types.INITIAL_FETCH_REPORT,
  payload,
});

export const setReportPage = (payload) => ({
  type: types.SET_REPORT_PAGE,
  payload,
});

export const setReportRow = (payload) => ({
  type: types.SET_REPORT_ROW,
  payload,
});
